import { render } from "./PopUp4.vue?vue&type=template&id=54aa2ca5&scoped=true"
import script from "./PopUp4.vue?vue&type=script&lang=js"
export * from "./PopUp4.vue?vue&type=script&lang=js"

import "./PopUp4.vue?vue&type=style&index=0&id=54aa2ca5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54aa2ca5"]])

export default __exports__